import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import AdminGuard from 'utils/route-guard/AdminGuard';
import AdminLayout from 'layout/AdminLayout';

const AdminMerchants = Loadable(lazy(() => import('pages/admin/merchants')));
const AdminPayments = Loadable(lazy(() => import('pages/admin/payments')));
const AdminReports = Loadable(lazy(() => import('pages/admin/reports')));

// Todas as páginas do admin partilham o mesmo layout (header, menu e seletor de modo)
const AdminRoutes = {
  path: '/admin',
  element: (
    <AdminGuard>
      <AdminLayout />
    </AdminGuard>
  ),
  children: [
    { index: true, element: <Navigate to="merchants" replace /> },
    { path: 'merchants', element: <AdminMerchants /> },
    { path: 'payments', element: <AdminPayments /> },
    { path: 'reports', element: <AdminReports /> }
  ]
};

export default AdminRoutes;
